module.exports = __webpack_public_path__ + "static/img/CARD2.cf145c45.png";